export abstract class QueryParam<T> {
  public get key() {
    return this._key
  }

  public get value() {
    return this._value
  }

  public constructor(protected _key: string, protected _value: T) {}

  abstract add(value: T)
}



// WEBPACK FOOTER //
// ./node_modules/@mprep/shared/lib/core/models/uri/query-param/query-param.ts